import React from "react"
import { Icon } from "components/Icons"
import { Wrapper, Text } from "./styles"

const ScrollToSeeMore = ({type}) => (
<Wrapper>
    <Icon type={type} />
    <Text>scrolluj, aby<br></br>zobaczyć więcej</Text>
</Wrapper>
)

export { ScrollToSeeMore }
